var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-4 mt-8 mb-16"},[_c('recurringTicketsBar'),_c('div',[_c('tableComponent',{staticClass:"mx-4"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }